import { render } from "./AgentProfile.vue?vue&type=template&id=7055840a&scoped=true&lang=pug"
import script from "./AgentProfile.vue?vue&type=script&lang=js"
export * from "./AgentProfile.vue?vue&type=script&lang=js"

import "./AgentProfile.vue?vue&type=style&index=0&id=7055840a&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7055840a"]])

export default __exports__